import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PaymentOptionsModalContent from './PaymentOptions';
import AddPaymentMethodModalContent from '../AddPaymentMethod';
import ReviewModalContent from './Review';
import EmptyModalContent from '../Empty';
import moneyUtils from '../../../utils/moneyUtils';
import ModalMessage from '../../UI/organisms/ModalMessage';
import * as StripeActions from '../../../actions/stripeMethod';
import * as PaymentActions from '../../../actions/payment';
import * as AppLoadingActions from '../../../actions/appLoading';
import { withTranslation } from 'next-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { useStripe } from '@stripe/react-stripe-js';

function mapStateToProps(state) {
  const { paymentMethod, payment } = state;
  return {
    savingCard: paymentMethod.saving,
    loadingCard: paymentMethod.loading,
    loaded: paymentMethod.loaded,
    stripeCard: paymentMethod.card,
    waitingPaypalToken: paymentMethod.waitingPaypalToken,
    currentPlan: payment.currentPlan,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    paymentActions: bindActionCreators<any, any>(PaymentActions, dispatch),
    stripeActions: bindActionCreators<any, any>(StripeActions, dispatch),
    appLoadingActions: bindActionCreators<any, any>(
      AppLoadingActions,
      dispatch,
    ),
  };
}

const CheckoutModalContent = (props) => {
  const {
    loaded,
    stripeActions,
    stripeCard,
    plan,
    paymentActions,
    hideModal,
    message,
    messageType,
    waitingPaypalToken,
    currentPlan,
  } = props;
  const hasActiveSubscription = currentPlan && currentPlan.id !== '0';
  const stripe = useStripe();
  const [step, setStep] = useState(0);
  const [chosenMethod, setChosenMethod] = useState(null);

  useEffect(() => {
    if (!loaded) {
      stripeActions.fetchCard();
    } else {
      setStep(1);
    }
  }, [loaded, stripeActions]);

  useEffect(() => {
    if (chosenMethod === 'Stripe' && stripeCard) {
      setStep(3);
    }
  }, [chosenMethod, stripeCard]);

  const handleSubscribe = () => {
    if (stripeCard) {
      const currency = moneyUtils.stripeCountryToCurrency(stripeCard.country);
      const price = moneyUtils.getPrice(plan.prices, currency);
      paymentActions.subscribeWithStripe(price.id, stripe);
    }
  };

  const onPickMethod = (val) => {
    let nextChosenMethod = 'PayPal';
    let nextStep = 3;
    if (val === 'Stripe') {
      nextChosenMethod = 'Stripe';
      if (!stripeCard) nextStep = 2;
    }
    setStep(nextStep);
    setChosenMethod(nextChosenMethod);
  };

  const nextStep = (e = null) => {
    if (e) e.preventDefault();
    if (step !== 2) {
      setStep(step + 1);
    }
  };
  switch (step) {
    case 0:
      return (
        <EmptyModalContent width={'420px'} height={'500px'} loading={true} />
      );
    case 1:
      return (
        <PaymentOptionsModalContent
          nextStep={onPickMethod}
          hideModal={hideModal}
          message={message}
          messageType={messageType}
          hasActiveSubscription={hasActiveSubscription}
        />
      );
    case 2:
      return (
        <AddPaymentMethodModalContent
          isStepModal={true}
          nextStep={nextStep}
          hideModal={hideModal}
          message={message}
          messageType={messageType}
        />
      );
    case 3:
      return (
        <ReviewModalContent
          chosenMethod={chosenMethod}
          stripeCard={stripeCard}
          plan={plan}
          isStepModal={true}
          nextStep={nextStep}
          hideModal={hideModal}
          handleSubscribe={handleSubscribe}
          message={message}
          messageType={messageType}
          waitingPaypalToken={waitingPaypalToken}
        />
      );
    case 4:
      return (
        <EmptyModalContent width={'420px'} height={'500px'}>
          <Card className="z-50">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle>Subscription Completed</CardTitle>
              <button type="button" className="modal-close" onClick={hideModal}>
                <span className="sr-only">Close</span>
                <X className="h-5 w-5" aria-hidden="true" />
              </button>
            </CardHeader>
            <CardContent>
              <ModalMessage message={message} messageType={messageType} />
              <div className="">
                <h4 className="text-center text-lg">Subscried</h4>
              </div>
            </CardContent>
          </Card>
        </EmptyModalContent>
      );
  }
};

const WrappedContent = withTranslation('common')(CheckoutModalContent);
const ConnectedContent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WrappedContent);

export const CheckoutModal = (props) => {
  const [StripeProviderComponent, setStripeProviderComponent] = useState(null);

  useEffect(() => {
    import('../../UI/organisms/Stripe/StripeProvider').then((module) => {
      setStripeProviderComponent(() => module.StripeProvider);
    });
  }, []);

  if (!StripeProviderComponent) {
    return null;
  }

  return (
    <StripeProviderComponent>
      <ConnectedContent {...props} />
    </StripeProviderComponent>
  );
};
